import { MutationTree } from 'vuex';
import { DocumentSignState } from './state';

const mutations: MutationTree<DocumentSignState> =  {
  SET_VERIFICATION_STATUS(state, status) {
      state.verificationStatus = status;
  },
};

export default mutations;